import React from 'react'
import { sanitizeURL } from '@manychat/manyui'

interface LinkBlockProps {
  text: string
  link?: {
    url: string
    name: string
  }
  dataTestId?: string
}

export const LinkBlock = (props: LinkBlockProps) => {
  return (
    <div data-test-id={props.dataTestId} className="m-t panel panel-info p-a-xs">
      <span className="d-block text-black">{props.text}</span>
      {props.link && (
        <a
          className="text-primary"
          href={sanitizeURL(props.link.url)}
          target="_blank"
          rel="noreferrer"
        >
          {props.link.name}
        </a>
      )}
    </div>
  )
}
